var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { filter, values } from 'lodash';
import resources from 'app/store/resources';
import { getResources } from 'app/store/selectors/getResources';
import { fetchDashboardData, fetchOneDashboard } from 'app/store/reducers/dashboards';
import { selectedDashboardSelector } from 'app/store/selectors/dashboards';
import { widgetsByDashboardSelector } from 'app/store/selectors/widgets';
import Loader from 'app/components/Loader/Loader.jsx';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
import DashboardWidgets from 'app/pages/Project/ProductionManagement/Dashboards/DashboardWidgets/DashboardWidgets';
import DashboardHeader from 'app/pages/Project/ProductionManagement/Dashboards/DashboardHeader/DashboardHeader';
import { permission } from 'app/containers/Permissions';
import classes from 'app/pages/Project/ProductionManagement/Dashboards/styles.module.scss';
const Dashboard = () => {
    const { projectId, dashboardId } = useParams();
    const dispatch = useDispatch();
    const isSupervisor = permission(['projet_global__supervisor']);
    const isWidgetSupervisor = (widget, allWidgets) => {
        const widgetHasParent = Boolean(widget.parent);
        if (!widgetHasParent && !widget.rel_dashboardWidgetInst.isSupervisor) {
            return false;
        }
        if (widgetHasParent) {
            const widgetParent = allWidgets.find((wid) => wid.id === widget.parent);
            if (widgetParent) {
                const isSupervisor = widget.rel_dashboardWidgetInst.isSupervisor || isWidgetSupervisor(widgetParent, allWidgets);
                return isSupervisor;
            }
        }
        return true;
    };
    const [loading, setLoading] = useState(false);
    const [dashboardLayout, setDashboardLayout] = useState([]);
    const [activeEpisodesByWidget, setActiveEpisodesByWidget] = useState([]);
    const progressionStatus = getResources(undefined, 'progressionStatus');
    const stepProjects = getResources(undefined, 'steps');
    const allEpisodes = useSelector((state) => filter(state.assets.resources, (asset) => asset.assetType === 'ep'));
    const activeDashboard = useSelector(selectedDashboardSelector(dashboardId));
    const dashboardWidgets = useSelector(widgetsByDashboardSelector(dashboardId));
    const widgets = isSupervisor
        ? dashboardWidgets
        : dashboardWidgets.filter((widget) => !isWidgetSupervisor(widget, dashboardWidgets));
    const saveDashboardLayoutsInLS = (updatedLayout) => {
        let dashboardsLs = {};
        const localStorageDashboardsData = localStorage.getItem('dashboardLayouts');
        if (localStorageDashboardsData) {
            dashboardsLs = JSON.parse(localStorageDashboardsData);
        }
        const updatedLsDashboards = Object.assign(Object.assign({}, dashboardsLs), { [projectId]: updatedLayout });
        localStorage.setItem('dashboardLayouts', JSON.stringify(updatedLsDashboards));
    };
    const saveDashboardLayoutLocally = (newLayouts) => {
        setDashboardLayout((prevState) => {
            const updatedLayout = prevState.map((layout) => {
                const el = newLayouts.find((nl) => nl.i === layout.i);
                if (el) {
                    return Object.assign(Object.assign({}, layout), { h: el.h, w: el.w, x: el.x, y: el.y });
                }
                return layout;
            });
            saveDashboardLayoutsInLS(updatedLayout);
            return updatedLayout;
        });
    };
    const generateLayouts = (widgets) => {
        const layouts = widgets.map((widget) => {
            var _a, _b;
            const dashboardsLs = localStorage.getItem('dashboardLayouts');
            if (dashboardsLs) {
                const lsLayout = ((_a = JSON.parse(dashboardsLs)) === null || _a === void 0 ? void 0 : _a[projectId]) || [];
                const lsWidgetLayout = lsLayout.find((lay) => lay.i === widget.id);
                if (lsWidgetLayout) {
                    return lsWidgetLayout;
                }
            }
            const savedWidgetLayout = (_b = activeDashboard.config.layout) === null || _b === void 0 ? void 0 : _b.find((lay) => lay.i === widget.id);
            if (savedWidgetLayout) {
                return savedWidgetLayout;
            }
            if (widget.widgetType === WIDGET_TYPES.CONTAINER) {
                return {
                    w: 6,
                    h: 22,
                    x: 0,
                    y: 0,
                    i: widget.id,
                    name: widget.name,
                    moved: false,
                    static: false,
                };
            }
            return {
                w: 6,
                h: 10,
                x: 0,
                y: 0,
                i: widget.id,
                name: widget.name,
                moved: false,
                static: false,
            };
        });
        return layouts;
    };
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const promises = [
                permission(['projet_dashboards__read']) && dispatch(fetchOneDashboard(dashboardId)),
                dispatch(fetchDashboardData(activeDashboard.id)),
                !allEpisodes.length &&
                    resources.assets.fetchEpisodes(projectId, {
                        params: {
                            queries: { page_size: 1000 },
                        },
                    }),
                !values(stepProjects).length && resources.steps.fetchByProject(projectId),
            ];
            yield Promise.all(promises);
            setLoading(false);
        }))();
    }, [dashboardId]);
    useEffect(() => {
        if (!loading) {
            const generatedLayouts = generateLayouts(widgets);
            const actEpisodes = widgets.map((widget) => {
                var _a;
                return {
                    widgetId: widget.id,
                    episodes: (_a = widget.config.episodes) !== null && _a !== void 0 ? _a : [],
                };
            });
            setActiveEpisodesByWidget(actEpisodes);
            setDashboardLayout(generatedLayouts);
        }
    }, [loading]);
    if (loading)
        return _jsx(Loader, {});
    return (_jsxs("div", { className: "fullHeight overflowYAuto relative marginLeft10 marginRight10", children: [_jsx(DashboardHeader, { projectId: projectId, dashboardId: dashboardId, activeDashboard: activeDashboard }), !loading && widgets.length === 0 ? (_jsx("div", { className: classes.fallbackScreen, children: "This dashboard has no widget" })) : (_jsx(DashboardWidgets, { allEpisodes: allEpisodes, allLayouts: dashboardLayout, widgets: widgets, stepProjects: stepProjects, dashboardLayout: dashboardLayout, setDashboardLayout: setDashboardLayout, progressionStatus: progressionStatus, nested: false, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, saveDashboardLayoutLocally: saveDashboardLayoutLocally }))] }));
};
export default Dashboard;
